/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('billing', [
  'plan',
  'getBalog',
]);

function plan() {
  return createAPIAction(
    types.plan,
    {
      endpoint: '/accounting/plan',
    })();
}

function getBalog(id) {
  return createAPIAction(
    types.getBalog,
    {
      endpoint: `/charging/${id}/balogs`,
    },
  )();
}

export default {
  plan,
  getBalog,
};




// WEBPACK FOOTER //
// ./src/redux/actions/billing.js